'use client'

import { useState } from 'react'
import { CopyIcon, CheckIcon } from 'lucide-react'
import { Tooltip } from './tooltip'
import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'

interface CopyButtonProps {
  text: string
  fieldId: string
}

export const CopyButton = ({ text, fieldId }: CopyButtonProps) => {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  const [copied, setCopied] = useState(false)

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true)
        setTimeout(() => {
          setCopied(false)
        }, 2000)
      })
      .catch((err) => {
        console.error('Failed to copy:', err)
      })
  }

  return (
    <Tooltip text={copied ? t('common.copied') : t('common.copy')}>
      <button className="text-primary-500 hover:text-primary-600" onClick={copyToClipboard}>
        {copied ? <CheckIcon className="h-4 w-4" /> : <CopyIcon className="h-4 w-4" />}
      </button>
    </Tooltip>
  )
}
